import { useComputedColorScheme } from "@mantine/core";

/**
 * Returns a function that adjusts a Mantine colour name for the active colour
 * scheme. Filled badges/icons keep `variant="filled"` everywhere, but in dark
 * mode the colour is shifted to a darker shade (e.g., `blue` → `blue.9`) so
 * the saturated `<color>.6` default doesn't read as a glowing chip on a dark
 * surface.
 *
 * Usage:
 *   const colorFor = useCognitiveColor();
 *   <Badge color={colorFor("blue")} variant="filled" />
 */
export function useCognitiveColor(): (baseColor: string) => string {
  const scheme = useComputedColorScheme("light");
  if (scheme === "dark") {
    return (color: string) => `${color}.9`;
  }
  return (color: string) => color;
}
